(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .factory('action-form-validation', actionFunc);

    function actionFunc($q, FormBuilderService, lodash, $timeout) {
        return function(options, evtData, actionResponse) {
            $q.when(run());

            function run() {
                const formId = lodash.get(options, 'formId', false);
                const summaryField = lodash.get(options, 'summaryField', 'summary');
                if (!formId) return false;

                const fbService = FormBuilderService.get(formId);
                const container = lodash.get(options, 'classTag', 'html,body');
                const animateOffset = lodash.get(options, 'offsetHeight', 50);
                if (fbService.elementsService) {
                    fbService.elementsService.setValidationRules(actionResponse.response.rules, actionResponse.response.summary, true, summaryField);
                }

                return $timeout(function () {
                    if (lodash.has(fbService, 'validation.summary') && fbService.validation.summary) {
                        if (angular.element('.callout').length > 0) {
                            angular.element(container).animate({
                                scrollTop: angular.element('.callout').offset().top - animateOffset
                            }, 500);
                        }
                    } else {
                        if (angular.element('.error, .sub-form-row-error').length > 0) {
                            angular.element(container).animate({
                                scrollTop: angular.element('.error, .sub-form-row-error').offset().top - animateOffset
                            }, 500);
                        }
                    }
                });
            }
        };
    }
})();